<main class="split" role="status" [attr.aria-label]="'documentEditor.generating' | translate">
  <section class="stage">
    <div class="page">
      @for (width of lines; track $index) {
        <span class="bar" [style.width.%]="width"></span>
      }
    </div>
  </section>

  <aside class="side">
    @for (field of fields; track field) {
      <span class="bar input"></span>
    }
  </aside>
</main>
